// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiSelector_Mxp6a {
  border: 1px solid var( --color-base200 );
  padding-left: 0.35em;
  padding-right: 0.35em;
  padding-bottom: var( --size-padSmall );
  background-color: var( --color-white );
}
.multiSelector_Mxp6a .tag_u5Trq {
  font: normal 13px/20px Inter;
  color: #495a6e;
  border: 1px solid var( --color-background3 );
  padding: 0.35em;
  overflow: hidden;
  margin-top: var( --size-padSmall );
  white-space: nowrap;
  margin-left: var( --size-padSmall );
  text-overflow: ellipsis;
  border-radius: var( --size-padSmall );
  background-color: var( --color-background3 );
}
.multiSelector_Mxp6a.multiSelector-conditionText_Ow4_M {
  min-width: 250px;
  max-width: 300px;
}
.multiSelector_Mxp6a.multiSelector-conditionTags_He85x.multiSelector-comparator_O8W2H {
  min-height: 38px;
}
.multiSelector_Mxp6a.multiSelector-formInput_j1_BQ {
  min-height: 42px;
}`, "",{"version":3,"sources":["webpack://./src/theme/MultiSelector.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,qBAAqB;EACrB,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,mCAAmC;EACnC,uBAAuB;EACvB,qCAAqC;EACrC,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".multiSelector {\n  border: 1px solid var( --color-base200 );\n  padding-left: 0.35em;\n  padding-right: 0.35em;\n  padding-bottom: var( --size-padSmall );\n  background-color: var( --color-white );\n}\n.multiSelector .tag {\n  font: normal 13px/20px Inter;\n  color: #495a6e;\n  border: 1px solid var( --color-background3 );\n  padding: 0.35em;\n  overflow: hidden;\n  margin-top: var( --size-padSmall );\n  white-space: nowrap;\n  margin-left: var( --size-padSmall );\n  text-overflow: ellipsis;\n  border-radius: var( --size-padSmall );\n  background-color: var( --color-background3 );\n}\n.multiSelector.multiSelector-conditionText {\n  min-width: 250px;\n  max-width: 300px;\n}\n.multiSelector.multiSelector-conditionTags.multiSelector-comparator {\n  min-height: 38px;\n}\n.multiSelector.multiSelector-formInput {\n  min-height: 42px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiSelector": `multiSelector_Mxp6a`,
	"tag": `tag_u5Trq`,
	"multiSelector-conditionText": `multiSelector-conditionText_Ow4_M`,
	"multiSelector-conditionTags": `multiSelector-conditionTags_He85x`,
	"multiSelector-comparator": `multiSelector-comparator_O8W2H`,
	"multiSelector-formInput": `multiSelector-formInput_j1_BQ`
};
export default ___CSS_LOADER_EXPORT___;
